import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import './ModalSincronizacao.css';

/**
 * Modal de confirmação para sincronização de aulas
 *
 * Exibe informações detalhadas sobre o que será feito na sincronização
 * e pede confirmação do usuário antes de executar.
 *
 * @param {Object} props
 * @param {boolean} props.show - Se o modal está visível
 * @param {Function} props.onConfirm - Callback ao confirmar sincronização
 * @param {Function} props.onCancel - Callback ao cancelar
 * @param {Object} props.verificacao - Dados da verificação de sincronização
 * @param {boolean} props.isLoading - Se está executando a sincronização
 */
const ModalSincronizacao = ({ show, onConfirm, onCancel, verificacao, isLoading }) => {
  if (!verificacao) return null;

  const { diferenca, tipo_sincronizacao, aulas_padrao, aulas_facilitador, qtd_apresentacoes_faltantes } = verificacao;
  const aulasPalavra = Math.abs(diferenca) === 1 ? 'aula' : 'aulas';

  const getDescricaoAcao = () => {
    if (tipo_sincronizacao === 'adicionar') {
      return (
        <ul className="sync-actions-list">
          <li>
            <strong>Adicionar {Math.abs(diferenca)} {aulasPalavra}</strong> ao final do seu material
          </li>
          <li>
            Incluir <strong>{qtd_apresentacoes_faltantes} {qtd_apresentacoes_faltantes === 1 ? 'apresentação' : 'apresentações'}</strong> novas do material padrão
          </li>
          <li>
            Todas as suas aulas atuais serão <strong>mantidas intactas</strong>
          </li>
        </ul>
      );
    } else {
      return (
        <ul className="sync-actions-list">
          <li>
            <strong>Remover {Math.abs(diferenca)} {aulasPalavra}</strong> do final do seu material
          </li>
          <li>
            As apresentações dessas aulas serão <strong>movidas para a penúltima aula</strong>
          </li>
          <li>
            <strong>Nenhuma apresentação será perdida</strong>
          </li>
        </ul>
      );
    }
  };

  return (
    <Modal show={show} onHide={onCancel} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {tipo_sincronizacao === 'adicionar' ? '🎯 Sincronizar Material' : '📝 Ajustar Material'}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="sync-modal-content">
          <div className="sync-info-card">
            <h6>Situação Atual:</h6>
            <div className="sync-stats">
              <div className="sync-stat">
                <span className="sync-stat-label">Material Padrão:</span>
                <span className="sync-stat-value">{aulas_padrao} {aulas_padrao === 1 ? 'aula' : 'aulas'}</span>
              </div>
              <div className="sync-stat">
                <span className="sync-stat-label">Seu Material:</span>
                <span className="sync-stat-value">{aulas_facilitador} {aulas_facilitador === 1 ? 'aula' : 'aulas'}</span>
              </div>
            </div>
          </div>

          <div className="sync-actions-card">
            <h6>Esta ação irá:</h6>
            {getDescricaoAcao()}
          </div>

          <div className="sync-note">
            <strong>📌 Importante:</strong> Após a sincronização, você poderá reorganizar as apresentações
            da forma que preferir para melhor atender sua turma!
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel} disabled={isLoading}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={onConfirm}
          disabled={isLoading}
          className="sync-confirm-button"
        >
          {isLoading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Sincronizando...
            </>
          ) : (
            <>
              Sim, sincronizar agora
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalSincronizacao;
